var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ql-snow"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":""},on:{"click-left":_vm.back}}),(_vm.info)?_c('div',{staticClass:"info ql-editor",domProps:{"innerHTML":_vm._s(_vm.info.content)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }